// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    projectId: 'migam-9f0be',
    // appId: '1:420110880413:web:8cbd4db9c6f507dff50e74',
    storageBucket: 'migam-9f0be.appspot.com',
    locationId: 'europe-west',
    apiKey: 'AIzaSyAa0kxrdvqhDuZzuNU63kq2U6UrGn9oSQ8',
    authDomain: 'migam-9f0be.firebaseapp.com',
    // messagingSenderId: '420110880413',
  },
  region: "europe-west1",
  production: false,
  reCaptchaSiteKey: '6Lf3G44aAAAAAGlFMjjxds17OFwovqbw4CYkBjL3',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
